import React from 'react';
import { Entity } from '../../types/index';
import { Icon } from '@ant-design/compatible';

export const BundledPages = ({
  width,
  docWidth,
  docHeight,
  entity,
  origin,
}: {
  width: number;
  docWidth: number;
  docHeight: number;
  entity: Entity;
  origin: 'row' | 'nav';
}) => {
  return (
    <div
      className="flex justify-center items-center absolute"
      style={{
        height: docHeight,
        top: origin === 'row' ? '1em' : '6px',
        left: origin === 'row' ? docWidth + width + 3 : docWidth + 1,
      }}>
      {entity.length > 1
        ? new Array(entity.length - 1).fill('x').map((_, i) => {
            return (
              <div
                key={i}
                style={{
                  background: `rgba(250, 250, 250, ${0.9 - i * 0.1})`,
                  height: `${docHeight - (i + 1) * (origin === 'row' ? 20 : 10)}px`,
                  width: width,
                  border: '1px solid #c1c1c1',
                  borderLeft: 'none',
                }}></div>
            );
          })
        : null}
    </div>
  );
};

export const FailedToLoadPage = ({
  width,
  height,
  style,
}: {
  width: number;
  height: number;
  style?: React.CSSProperties;
}) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: width,
        height: height,
        padding: '1em',
        textAlign: 'center',
        background: 'rgba(220,220,220)',
        ...style,
      }}>
      <Icon type="exclamation-circle" />
      <div style={{ paddingTop: '1em' }}>Failed to load page</div>
    </div>
  );
};

export const AsideSectionMask = ({
  asideSectionMask,
  documentScrollHeight,
}: {
  asideSectionMask: React.RefObject<HTMLDivElement>;
  documentScrollHeight: { start: number; end: number };
}) => {
  return (
    <div
      ref={asideSectionMask}
      style={{
        position: 'absolute',
        top: `${documentScrollHeight.start}%`,
        left: '1em',
        right: '1em',
        bottom: `${100 - documentScrollHeight.end}%`,
        border: '2px solid rgba(21, 134, 255, 0.8)',
        background: 'rgba(21,134,255,0.1)',
        pointerEvents: 'none',
      }}></div>
  );
};
